import { Component, Input, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IControls } from 'bi-interfaces';
import { BIModulesService } from '../../bi-modules.service';
@Component({
  selector: 'bi-floating-text-area',
  templateUrl: './bi-floating-text-area.component.html',
  styleUrls: ['./bi-floating-text-area.component.scss']
})
export class BiFloatingTextAreaComponent {
  @Input() Control!: IControls
  @Input() FormGroup!: FormGroup;
  public FormControl!: FormControl;
  @Input() ColsSizes: string[] = ['71%', '27%'];
  constructor(private translateService: TranslateService,public biService: BIModulesService,
    ) {
    }
  
    ngOnChanges(changes: SimpleChanges): void {
      if (changes['FormGroup'] || changes['Control']) {
        try {
          this.FormControl = this.FormGroup.controls[this.Control.Name] as FormControl;
        } catch (error) {
          console.error(`An error occurred while assigning FormControl: ${this.Control.Name}`, error);
        }
      }
    }
}
